import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AlertController, Events, NavController } from 'ionic-angular';
// import { Auth, User } from '@ionic/cloud-angular';
import { TabsPage } from '../tabs/tabs';
import { SignupPage } from '../signup/signup';
import { LoggerService } from '../../providers/logger-service';
import { SupportPage } from '../support/support';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import {AuthService} from '../../providers/auth-service';


declare let dataLayer: Array<any>;

@Component({
  selector: 'page-user',
  templateUrl: 'login.html'
})

export class LoginPage {
  // login: {username?: string, password?: string} = {};
  submitted = false;
  loginForm: FormGroup;

  constructor(public alertCtrl: AlertController,
              public _auth0: AuthService,
              public navCtrl: NavController,
              public events: Events,
              public formBuilder: FormBuilder,
              private logger: LoggerService,
              public afAuth: AngularFireAuth) {

    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      passwd: ['',Validators.required]
    });

  }

  signInWithLinkedIn(): void {
    this._auth0.login();
  };
  //TODO:
  /*
   Fix test run
   write custom log in for linkedin"

   add loading controller while pressing login until *actually* being logged in
   */




  logout(): void{
    this._auth0.logout();
  }

  signInWithGoogle(): void{

    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  signInWithTwitter(): void{

    this.afAuth.auth.signInWithPopup(new firebase.auth.TwitterAuthProvider());
  }

  signInWithFacebook(): void {
    this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider());

  }

  //
  // private socialLoginMethod(method: AuthProviders): void {
  //   if(this.loginForm.valid) {
  //     this._auth.signInWithSocialNetwork(method)
  //       .then(() =>{
  //         this.onSignInSuccess(method)
  //       })
  //       .catch((err) => {
  //         this.onSignInFailure( method, err);
  //       });
  //   } else {
  //
  //     dataLayer.push({
  //       'appEventCategory': 'user',
  //       'appEventAction': 'onLoginFailure',
  //       'appEventLabel': 'onLogin button failure'
  //     });
  //     dataLayer.push({'event': 'appEvent'});
  //
  //     //TODO: http://www.charlesfarina.com/login-and-signup-naming-conventions-for-google-analytics/
  //     this.logger.log.warn('you need correct variables to log in');
  //
  //   }
  // };


  loginMethod(): void {
    if(this.loginForm.valid) {

      this.afAuth.auth.createUserWithEmailAndPassword(this.loginForm.value.email,this.loginForm.value.email)
        .then(() =>{
          this.onSignInSuccess('UserPasswd')
        })
        .catch((err) => {
          this.onSignInFailure('UserPasswd', err);
        });
    } else {

      dataLayer.push({
        'appEventCategory': 'user',
        'appEventAction': 'onLoginFailure',
        'appEventLabel': 'onLogin button failure'
      });
      dataLayer.push({'event': 'appEvent'});

      //TODO: http://www.charlesfarina.com/login-and-signup-naming-conventions-for-google-analytics/
      this.logger.log.warn('you need correct variables to log in');
    }
  };

  //TODO: this is not needed at this stage
  onSignup() {
    this.navCtrl.push(SignupPage);
  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'user',
      'screenName': 'LoginPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }

  private onSignInSuccess(method: string): void {

    this.events.publish('user:login');
    this.logger.log.debug("Display name " + this.afAuth.auth.currentUser);

    this.goToTabsPage();

    let authMethod: string = "'" + method.toString() + "'";
    dataLayer.push({
      'userID': 'voltiotestuser',
      'authenticationMethod': authMethod,
      'existinguser': 'Yes',
    });
    dataLayer.push({'event': 'userLoginSuccess'});
  }

  private onSignInFailure(method: string, err: Error): void {
    //TODO: Create a smarter alert controller - ie only raise support request on second try
    // this.events.publish('user:login');

    this.logger.log.error("Failure to log in " + err.name );
    this.logger.log.error("Failure to log in " + err.message);
    this.logger.log.debug("Failure to login name " + this.afAuth.auth.currentUser);

    let alert = this.alertCtrl.create({
      title: 'Error Logging you in (' + err.message + ')',
      subTitle: 'Please try again',
      buttons: [
        'Cancel'
      ]
    });

    alert.addInput({
      name: 'username',
      value: this.loginForm.value.email,
      placeholder: 'username'
    });

    alert.addButton({
      text: 'Raise support issue',
      handler: () => {
        this.goToSupportPage();
      }
    });

    alert.present();


    let authMethod: string = "'" + method.toString() + "'";
    let errMessage: string = "'" + err.message + "'";

      dataLayer.push({
      'userID': 'voltiotestuser',
      'authenticationMethod': authMethod,
      'existinguser': 'Yes',
      'validationError': errMessage
    });
    dataLayer.push({'event': 'userLoginFailure'});
  }


  showPassword(input: any): any {
    input.type = input.type === 'password' ?  'text' : 'password';
  }

  //TODO: add subject and username to support page
  //TODO: Move the goto pages to a general class if possible
  private goToSupportPage(){
    this.navCtrl.push(SupportPage).then(
      response => {
        this.logger.log.debug('Response ' + response);
      },
      error => {
        this.logger.log.error('Error: ' + error);
      }
    ).catch(exception => {
      this.logger.log.error('Exception ' + exception)
    });

  }
  private goToTabsPage(){
    this.navCtrl.push(TabsPage).then(
      response => {
        this.logger.log.debug('Response ' + response);
      },
      error => {
        this.logger.log.error('Error: ' + error);
      }
    ).catch(exception => {
      this.logger.log.error('Exception ' + exception)
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts